module.exports = __webpack_public_path__ + "img/rope-external-wall-repaint.8750ce83.jpg";